import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import fields from './fields'

const filters = [
  { name: 'Filter by code', prop: 'filters.code_ilike', type: 'text', enabled: true }
]

const defaults = {
  order: [{ column: 'available_at', direction: 'desc' }],
  where: { product_id: null }
}

const Discounts = props => (
  <List
    title='Discounts'
    apiPath='admin/discounts'
    columns={fields}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Discounts
